import * as types from '../const/action.types';

export function STS(state = {}, action) {
    switch (action.type) {
        case types.LOAD_STS_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function STSHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.STS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function STSIsLoading(state = false, action) {
    switch (action.type) {
        case types.STS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/sts.reducer.js